/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import * as fromLoading from "./loading";
import * as fromAuth from "./auth";
import * as fromGlobal from "./global";
import * as fromStall from "./stall";
import * as fromCategory from "./category";
import * as fromVerification from "./verification";
import * as fromFood from "./food";
import * as fromFavourite from "./favourite";
import * as fromWallet from "./wallet";
import * as fromMe from "./me";
import * as fromUser from "./user";
import * as fromReview from "./review";
import * as fromSearch from "./search";
import * as fromProfile from "./profile";
import * as fromPage from "./page";
import * as fromPoint from "./point";
import * as fromNotification from "./notification";
import * as fromWarning from "./warning";
import * as fromCommon from "./common";
import * as fromBanner from "./banner";

// loading
export const getAuthLoading = state =>
  fromLoading.getAuthLoading(state.loading);

// auth
export const getAuthRememberMe = state =>
  fromAuth.getAuthRememberMe(state.auth);
export const getAuthMobileNumber = state =>
  fromAuth.getAuthMobileNumber(state.auth);
export const getAuthToken = state => fromAuth.getAuthToken(state.auth);
export const getAuthLoginLoading = state =>
  fromAuth.getAuthLoginLoading(state.auth);
export const getAuthSignUpLoading = state =>
  fromAuth.getAuthSignUpLoading(state.auth);
export const getPostForgetPasswordLoading = state =>
  fromAuth.getPostForgetPasswordLoading(state.auth);
export const getPostForgetPasswordItemToken = state =>
  fromAuth.getPostForgetPasswordItemToken(state.auth);
export const getPostForgetPasswordExpiryTimestamp = state =>
  fromAuth.getPostForgetPasswordExpiryTimestamp(state.auth);
export const getPostForgetPasswordStatus = state =>
  fromAuth.getPostForgetPasswordStatus(state.auth);
export const getPostResetPasswordWithPhoneLoading = state =>
  fromAuth.getPostResetPasswordWithPhoneLoading(state.auth);
export const getPostResetPasswordWithPhoneItemToken = state =>
  fromAuth.getPostResetPasswordWithPhoneItemToken(state.auth);
export const getPostResetPasswordWithPhoneStatus = state =>
  fromAuth.getPostResetPasswordWithPhoneStatus(state.auth);
export const getPostResetPasswordWithEmailLoading = state =>
  fromAuth.getPostResetPasswordWithEmailLoading(state.auth);
export const getPostResetPasswordWithEmailStatus = state =>
  fromAuth.getPostResetPasswordWithEmailStatus(state.auth);
export const getProfileStatus = state => fromAuth.getProfileStatus(state.auth);

// global
export const getIsRehydrationCompleted = state =>
  fromGlobal.getIsRehydrationCompleted(state.global);
export const getGlobalLanguage = state =>
  fromGlobal.getGlobalLanguage(state.global);

// stall
export const getStallListFilter = state =>
  fromStall.getStallListFilter(state.stall);
export const getStallListData = state =>
  fromStall.getStallListData(state.stall);
export const getStallListPagination = state =>
  fromStall.getStallListPagination(state.stall);
export const getCategoryFilterIDs = state =>
  fromStall.getCategoryFilterIDs(state.stall);
export const getStallListLoading = state =>
  fromStall.getStallListLoading(state.stall);
export const getStallHideLoading = state =>
  fromStall.getStallHideLoading(state.stall);
export const getStallDetailItem = (state, stallID) =>
  fromStall.getStallDetailItem(state.stall, stallID);
export const getStallDetailLoading = state =>
  fromStall.getStallDetailLoading(state.stall);
export const getSelectedFilterData = (state, stallID) =>
  fromStall.getSelectedFilterData(state.stall, stallID);
export const getStallListFilterData = state =>
  fromStall.getStallListFilterData(state.stall);
export const getStallFilterFoodTagWithID = (state, stallID) =>
  fromStall.getStallFilterFoodTagWithID(state.stall, stallID);
export const getStallListFilterFoodTag = state =>
  fromStall.getStallListFilterFoodTag(state.stall);
export const getStallListFilterMinPrice = state =>
  fromStall.getStallListFilterMinPrice(state.stall);
export const getStallListFilterMaxPrice = state =>
  fromStall.getStallListFilterMaxPrice(state.stall);
export const getStallListFilterMaxEta = state =>
  fromStall.getStallListFilterMaxEta(state.stall);
export const getStallFilterMinPrice = (state, stallID) =>
  fromStall.getStallFilterMinPrice(state.stall, stallID);
export const getStallFilterMaxPrice = (state, stallID) =>
  fromStall.getStallFilterMaxPrice(state.stall, stallID);
export const getStallFilterMaxEta = (state, stallID) =>
  fromStall.getStallFilterMaxEta(state.stall, stallID);

// category
export const getCategoryListData = state =>
  fromCategory.getCategoryListData(state.category);
export const getCategoryListPagination = state =>
  fromCategory.getCategoryListPagination(state.category);
export const getCategoryListLoading = state =>
  fromCategory.getCategoryListLoading(state.category);

// verification
export const getPhoneVerificationItem = state =>
  fromVerification.getPhoneVerificationItem(state.verification);
export const getPhoneVerificationRequestStatus = state =>
  fromVerification.getPhoneVerificationRequestStatus(state.verification);
export const getPhoneVerificationPassword = state =>
  fromVerification.getPhoneVerificationPassword(state.verification);
export const getMobileNumber = state =>
  fromVerification.getMobileNumber(state.verification);
export const getRequestPhoneVerificationLoading = state =>
  fromVerification.getRequestLoading(state.verification);
export const getVerifyCodeLoading = state =>
  fromVerification.getVerifyCodeLoading(state.verification);
export const getVerifyStatus = state =>
  fromVerification.getVerifyStatus(state.verification);

// food
export const getStallFoodData = state => fromFood.getStallFoodData(state.food);
export const getStallFoodPagination = state =>
  fromFood.getStallFoodPagination(state.food);
export const getStallFoodLoading = state =>
  fromFood.getStallFoodLoading(state.food);
export const getStallFoodHideLoading = state =>
  fromFood.getStallFoodHideLoading(state.food);
export const getFoodDetailItem = (state, foodID) =>
  fromFood.getFoodDetailItem(state.food, foodID);
export const getFoodDetailLoading = state =>
  fromFood.getFoodDetailLoading(state.food);
export const getFoodReviewListData = (state, foodID) =>
  fromFood.getFoodReviewListData(state.food, foodID);
export const getFoodReviewListPagination = (state, foodID) =>
  fromFood.getFoodReviewListPagination(state.food, foodID);
export const getFoodReviewLoading = state =>
  fromFood.getFoodReviewLoading(state.food);
export const getFoodReviewHideLoading = state =>
  fromFood.getFoodReviewHideLoading(state.food);

// favourite
export const getFavouriteFoodListData = state =>
  fromFavourite.getFavouriteFoodListData(state.favourite);
export const getFavouriteFoodListPagination = state =>
  fromFavourite.getFavouriteFoodListPagination(state.favourite);
export const getFavouriteFoodListLoading = state =>
  fromFavourite.getFavouriteFoodListLoading(state.favourite);
export const getFavouriteFoodListHideLoading = state =>
  fromFavourite.getFavouriteFoodListHideLoading(state.favourite);

// wallet
export const getWalletTopUpLoading = state =>
  fromWallet.getWalletTopUpLoading(state.wallet);
export const getWalletTopUpStatus = state =>
  fromWallet.getWalletTopUpStatus(state.wallet);
export const getMyWalletItem = state =>
  fromWallet.getMyWalletItem(state.wallet);
export const getMyWalletLoading = state =>
  fromWallet.getMyWalletLoading(state.wallet);
export const getWalletPaymentHistoryListItems = state =>
  fromWallet.getWalletPaymentHistoryListItems(state.wallet);
export const getWalletPaymentHistoryPagination = state =>
  fromWallet.getWalletPaymentHistoryPagination(state.wallet);
export const getWalletPaymentHistoryLoading = state =>
  fromWallet.getWalletPaymentHistoryLoading(state.wallet);
export const getWalletPaymentHistoryHideLoading = state =>
  fromWallet.getWalletPaymentHistoryHideLoading(state.wallet);
export const getWalletTopUpCreatePaymentItem = state =>
  fromWallet.getWalletTopUpCreatePaymentItem(state.wallet);
export const getWalletUpdateTopUpPaymentStatus = state =>
  fromWallet.getWalletUpdateTopUpPaymentStatus(state.wallet);

// user
export const getRequestCartFoodLoading = state =>
  fromUser.getRequestCartFoodLoading(state.user);
export const getUpdateCartFoodLoading = state =>
  fromUser.getUpdateCartFoodLoading(state.user);
export const getRequestCartFoodStatus = state =>
  fromUser.getRequestCartFoodStatus(state.user);
export const getUpdateCartFoodStatus = state =>
  fromUser.getUpdateCartFoodStatus(state.user);
export const getUserCartItem = state => fromUser.getUserCartItem(state.user);
export const getUserCartItemStallItem = (state, cartFoodId) =>
  fromUser.getUserCartItemStallItem(state.user, cartFoodId);
export const getUserCartLoading = state =>
  fromUser.getUserCartLoading(state.user);
export const getDeleteUserCartLoading = state =>
  fromUser.getDeleteUserCartLoading(state.user);
export const getDeleteUserCartStatus = state =>
  fromUser.getDeleteUserCartStatus(state.user);
export const getApplyUserCartWalletLoading = state =>
  fromUser.getApplyUserCartWalletLoading(state.user);
export const getApplyUserCartWalletStatus = state =>
  fromUser.getApplyUserCartWalletStatus(state.user);
export const getApplyUserCartPointLoading = state =>
  fromUser.getApplyUserCartPointLoading(state.user);
export const getApplyUserCartPointStatus = state =>
  fromUser.getApplyUserCartPointStatus(state.user);
export const getUserOrderDetailItem = state =>
  fromUser.getUserOrderDetailItem(state.user);
export const getUserOrderDetailLoading = state =>
  fromUser.getUserOrderDetailLoading(state.user);
export const getUserCheckoutStatus = state =>
  fromUser.getUserCheckoutStatus(state.user);
export const getUserCheckoutLoading = state =>
  fromUser.getUserCheckoutLoading(state.user);
export const getUserCheckoutItem = state =>
  fromUser.getUserCheckoutItem(state.user);
export const getIsUserCartItemEmpty = state =>
  fromUser.getIsUserCartItemEmpty(state.user);
export const getUserCartItemLength = state =>
  fromUser.getUserCartItemLength(state.user);
export const getUpdateUserCartTableLoading = state =>
  fromUser.getUpdateUserCartTableLoading(state.user);
export const getUserOrderListItems = state =>
  fromUser.getUserOrderListItems(state.user);
export const getUserOrderListPagination = state =>
  fromUser.getUserOrderListPagination(state.user);
export const getUserOrderListLoading = state =>
  fromUser.getUserOrderListLoading(state.user);
export const getUserOrderListHideLoading = state =>
  fromUser.getUserOrderListHideLoading(state.user);
export const getCancelOrderLoading = state =>
  fromUser.getCancelOrderLoading(state.user);
export const getCancelOrderStatus = state =>
  fromUser.getCancelOrderStatus(state.user);
export const getUserOrderUpdatePaymentLoading = state =>
  fromUser.getUserOrderUpdatePaymentLoading(state.user);
export const getOrderIndicatorStatus = state =>
  fromUser.getOrderIndicatorStatus(state.user);
export const getQueueInProgressItem = state =>
  fromUser.getQueueInProgressItem(state.user);
export const getQueueInProgressLoading = state =>
  fromUser.getQueueInProgressLoading(state.user);
export const getQueueReadyItem = state =>
  fromUser.getQueueReadyItem(state.user);
export const getQueueReadyLoading = state =>
  fromUser.getQueueReadyLoading(state.user);
export const getQueueCompleteItem = state =>
  fromUser.getQueueCompleteItem(state.user);
export const getQueueCompleteLoading = state =>
  fromUser.getQueueCompleteLoading(state.user);
export const getUserOrderCreatePaymentData = state =>
  fromUser.getUserOrderCreatePaymentData(state.user);
export const getUserOrderCreatePaymentStatus = state =>
  fromUser.getUserOrderCreatePaymentStatus(state.user);
export const getOrderSummaryTableStatus = state =>
  fromUser.getOrderSummaryTableStatus(state.user);
export const getOrderSummaryQrCode = state =>
  fromUser.getOrderSummaryQrCode(state.router);
export const getIsFoodOnlyStatus = state =>
  fromUser.getIsFoodOnlyStatus(state.user);
export const getUserOrderIsTableUpdatable = state =>
  fromUser.getUserOrderIsTableUpdatable(state.user);
export const getErrorType = state => fromUser.getErrorType(state.user);

// review
export const getReviewSubmitReviewLoading = state =>
  fromReview.getReviewSubmitReviewLoading(state.review);
export const getReviewSubmitReviewStatus = state =>
  fromReview.getReviewSubmitReviewStatus(state.review);

// me
export const getMeData = state => fromMe.getMeData(state.me);
export const getMeLoading = state => fromMe.getMeLoading(state.me);
export const getIsFacebookConnected = state =>
  fromMe.getIsFacebookConnected(state.me);

// search
export const getSearchResult = state =>
  fromSearch.getSearchResult(state.search);
export const getSearchLoading = state =>
  fromSearch.getSearchLoading(state.search);

// profile
export const getUpdateProfileStatus = state =>
  fromProfile.getUpdateProfileStatus(state.profile);
export const getUpdateProfileLoading = state =>
  fromProfile.getUpdateProfileLoading(state.profile);
export const getProfileDetails = state =>
  fromProfile.getProfileDetails(state.profile);
export const getProfileDetailsIsIncomplete = state =>
  fromProfile.getProfileDetailsIsIncomplete(state.profile);
export const getUpdateProfileBasicLoading = state =>
  fromProfile.getUpdateProfileBasicLoading(state.profile);

// point
export const getPointTransactionListData = state =>
  fromPoint.getPointTransactionListItems(state.point);
export const getPointTransactionListPagination = state =>
  fromPoint.getPointTransactionListPagination(state.point);
export const getPointTransactionListLoading = state =>
  fromPoint.getPointTransactionListLoading(state.point);
export const getPointTransactionListHideLoading = state =>
  fromPoint.getPointTransactionListHideLoading(state.point);

// page
export const getPageTncDataItem = state =>
  fromPage.getPageTncDataItem(state.page);
export const getPageTncDataLoading = state =>
  fromPage.getPageTncDataLoading(state.page);

// notication
export const getNotificationData = state =>
  fromNotification.getNotificationData(state.notification);
export const getNotificationItemsID = state =>
  fromNotification.getNotificationItemsID(state.notification);
export const getNotificationLoading = state =>
  fromNotification.getNotificationLoading(state.notification);

//warning
export const getWarning = state => fromWarning.getWarning(state.warning);
export const getWarningStatus = state =>
  fromWarning.getWarningStatus(state.warning);

//common
export const getDeliveryEnabledData = state =>
  fromCommon.getDeliveryEnabledData(state.common);
export const getOccupationData = state =>
  fromCommon.getOccupationData(state.common);
export const getTopUpItemData = state =>
  fromCommon.getTopUpItemData(state.common);
export const getTopUpAmount = state => fromCommon.getTopUpAmount(state.common);
export const getTopUpSummary = state =>
  fromCommon.getTopUpSummary(state.common);
export const getTopUpPayment = state =>
  fromCommon.getTopUpPayment(state.common);

//banner
export const getBannerItemList = state =>
  fromBanner.getBannerItemList(state.banner);
export const getShowBanner = state =>
  fromBanner.getShowBanner(state.banner);
export const getBannerLoading = state =>
  fromBanner.getBannerLoading(state.banner);
export const getBannerItem = state =>
  fromBanner.getBannerItem(state.items);
export const getBannerImage = state =>
  fromBanner.getBannerImage(state.items);



// WEBPACK FOOTER //
// ./src/selectors/index.js